import { SVGProps } from "react"
const CheckmarkIcon = ({ fill = "#A2C900" }: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={22} height={22} fill="none">
    <rect
      width={20}
      height={20}
      x={1}
      y={1}
      stroke={fill}
      strokeWidth={1.5}
      rx={10}
    />
    <path
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m8.5 10.5 2 2 4-4"
    />
  </svg>
)
export default CheckmarkIcon
